import PassengerForm from "./components/PassengerForm/PassengerForm";

export default function Passengers() {
  return (
    <div className="flex w-full flex-col">
      <PassengerForm/>
    </div>
  );
}

